/*
 *
 * Copyright (c) 1999-2021 Luciad All Rights Reserved.
 *
 * Luciad grants you ("Licensee") a non-exclusive, royalty free, license to use,
 * modify and redistribute this software in source and binary code form,
 * provided that i) this copyright notice and license appear on all copies of
 * the software; and ii) Licensee does not utilize the software in a manner
 * which is disparaging to Luciad.
 *
 * This software is provided "AS IS," without a warranty of any kind. ALL
 * EXPRESS OR IMPLIED CONDITIONS, REPRESENTATIONS AND WARRANTIES, INCLUDING ANY
 * IMPLIED WARRANTY OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE OR
 * NON-INFRINGEMENT, ARE HEREBY EXCLUDED. LUCIAD AND ITS LICENSORS SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE AS A RESULT OF USING, MODIFYING
 * OR DISTRIBUTING THE SOFTWARE OR ITS DERIVATIVES. IN NO EVENT WILL LUCIAD OR ITS
 * LICENSORS BE LIABLE FOR ANY LOST REVENUE, PROFIT OR DATA, OR FOR DIRECT,
 * INDIRECT, SPECIAL, CONSEQUENTIAL, INCIDENTAL OR PUNITIVE DAMAGES, HOWEVER
 * CAUSED AND REGARDLESS OF THE THEORY OF LIABILITY, ARISING OUT OF THE USE OF
 * OR INABILITY TO USE SOFTWARE, EVEN IF LUCIAD HAS BEEN ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGES.
 */
var UNDEFINED_HANDLE = "UNDEFINED_HANDLE";

function closeContextMenuHandler(event) {
  this.hideAll();
  event.stopPropagation();
}

function ContextMenuManager() {
  this._contextMenuMap = {};
  this._closeContextMenuClickHandler = closeContextMenuHandler.bind(this);
}

ContextMenuManager.prototype.registerContextMenu = function(contextMenu, handle) {
  handle = handle || UNDEFINED_HANDLE;
  if (!this._contextMenuMap[handle]) {
    this._contextMenuMap[handle] = [];
  }
  if (this._contextMenuMap[handle].indexOf(contextMenu) < 0) {
    this._contextMenuMap[handle].push(contextMenu);
  }
  contextMenu._handle = handle;
};

/**
 * Shows a context menu, while hiding all other menus with the same handle
 */
ContextMenuManager.prototype.showOnly = function(contextMenu, x, y, anchor) {
  var handle = contextMenu._handle;
  this.hideAll(handle);
  contextMenu.show(x, y, anchor);
  document.addEventListener("click", this._closeContextMenuClickHandler, false);
};

ContextMenuManager.prototype.hideAll = function(handle) {
  handle = handle || UNDEFINED_HANDLE;
  if (this._contextMenuMap[handle]) {
    this._contextMenuMap[handle].forEach(function(contextMenu) {
      contextMenu.hide();
    });
  }
  document.removeEventListener("click", this._closeContextMenuClickHandler);
};

export {ContextMenuManager};
